import './Footer.scss';

import React from 'react';
import { formatText } from 'core/i18n';

export const Footer = ({ buttonText, isHidden, onClickButton, isButtonDisabled }) => {
    const footerClass = `initial-section-footer ${isHidden ? 'initial-section-footer--hidden' : ''}`;

    return (
        <div className={footerClass}>
            {!isHidden && (
                <button
                    className="form__button form__button-secondary"
                    onClick={onClickButton}
                    aria-disabled={isButtonDisabled}
                >
                    {formatText(buttonText)}
                </button>
            )}
        </div>
    );
};
